
export const no_of_employees = [
    "1 to 10",
    "11 to 100",
    "101 to 1000",
    "1001 to 10000",
    "10001 to 100000",
    "100000 ++",
  ];
  
  export const allCountries = [
    {
      label: "India",
      value: "India",
    },
  ];
  